<lib-drawer-layout
    qaTag="multi-factor-auth-drawer"
    [hasFullScreenMode]="false">
    <ng-container title>
        <h3 i18n="@@CommonTwoFactorAuthenticationTitle">2-Factor Authentication (2FA)</h3>
    </ng-container>

    <ng-container content>
        <div class="p-4">
            <p class="typography-title-small" i18n="@@CommonStep1">Step 1</p>

            @if (!isMobile) {
                <p class="typography-body-medium pb-3" i18n="@@CommonMFAQRCodeInstruction ">Scan the QR code in your authenticator app (e.g. Google Authenticator, Authy etc.):</p>
                <div class="d-flex justify-content-center align-items-center">
                    @if (isLoading) {
                        <div class="scss-multi-factor-auth-qrcode-placeholder form-field-loading"></div>
                    } @else {
                        <div [attr.data-sb-qa]="'multi-factor-auth-drawer-qr-code'">
                            <img [src]="mfaSetup.QrCode" height="200px" width="200px">
                        </div>
                    }
                </div>
            }

            @if (isMobile) {
                <p class="typography-body-medium py-3" i18n="@@CommonMFAAddButtonInstructionMobile">Click the button below to add your account to the authenticator app automatically.</p>
            }
            @if (isTablet) {
                <p class="typography-body-medium py-3" i18n="@@CommonMFAAddButtonInstructionTablet">Or click the button below to add your account to the authenticator app automatically.</p>
            }
            @if (isMobileOrTablet) {
                <div class="d-flex justify-content-center align-items-center">
                    <lib-button
                        [kind]="ButtonKind.Primary"
                        [size]="ButtonSize.Medium"
                        [disabled]="isLoading"
                        [loading]="isLoading"
                        [suffixIcon]="Icon.Common.OpenInNew"
                        (clicked)="AddToAuthenticatorApp()">
                        <ng-container label i18n="@@CommonMFASetupAddToAuthenticatorButton">Add to Authenticator App</ng-container>
                    </lib-button>
                </div>
            }

            <form [formGroup]="mfaCodeForm" class="sb-legacy-form">
                <p class="typography-body-medium pt-3" i18n="@@CommonMFASecretKeyInstruction">Alternatively, manually enter the Secret Key in your authenticator app:</p>
                <div class="single-column-row pb-3 mt-2">
                    @if (showSecretCode) {
                        <div class="w-100 py-2 typography-title-small text-center background-base-50 scss-multi-factor-auth-secret-code-background">
                            {{secretCode}}
                        </div>
                    } @else {
                        <div>
                            <lib-button
                                [kind]="ButtonKind.Link"
                                [size]="ButtonSize.Medium"
                                [disabled]="mfaCodeForm.disabled"
                                (clicked)="showSecretCode = true;">
                                <ng-container label i18n="@@CommonMFASecretKeyShowSKey">Show Secret Key</ng-container>
                            </lib-button>
                        </div>
                    }
                </div>

                <hr>
                <p class="typography-title-small" i18n="@@CommonStep2">Step 2</p>
                <p class="typography-body-medium pb-3" i18n="@@CommonMFASetupCode1Instruction">Enter the code shown in your authenticator app:</p>
                <div class="three-column-row pb-3">
                    <lib-input-text [formControl]="mfaCodeForm.controls.Code1"
                        [maxCharacterLength]="6"
                        [isOptional]="false"
                        inputFilter="[0-9]"
                        placeholderText="Code 1"
                        [errorMessages]="mfaErrors">
                    </lib-input-text>
                </div>

                <p class="typography-body-medium pb-3" i18n="@@CommonMFASetupCode2Instruction">Wait until a new code is generated, and enter it below:</p>
                <div class="three-column-row pb-3">
                    <lib-input-text [formControl]="mfaCodeForm.controls.Code2"
                        [maxCharacterLength]="6"
                        [isOptional]="false"
                        inputFilter="[0-9]"
                        placeholderText="Code 2"
                        [errorMessages]="mfaErrors">
                    </lib-input-text>
                </div>

                @if (!enablingMFA) {
                    <lib-error
                        [control]="mfaErrorForm.controls.AlreadySetup"
                        [errors]="alreadySetupErrors">
                    </lib-error>

                    <lib-error
                        [control]="mfaErrorForm.controls.IncorrectCode"
                        [errors]="incorrectCodeErrors">
                    </lib-error>
                }
            </form>
        </div>
    </ng-container>

    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DrawerBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                qaTag="multi-factor-auth-setup-mfa-drawer-verify-and-continue-button"
                [loading]="mfaCodeForm.disabled && enablingMFA"
                [disabled]="mfaCodeForm.disabled"
                (clicked)="PrimaryAction()">
                <ng-container label i18n="@@CommonMFASetupVerifyAndContinueButtonText">
                    Verify & Continue
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                qaTag="multi-factor-auth-setup-mfa-drawer-cancel-button"
                [kind]="ButtonKind.NeutralSecondary"
                (clicked)="DismissAction()">
                <ng-container label i18n="@@CommonCancel">
                    Cancel
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-drawer-layout>